import React from 'react';
import SocialShare from './SocialShare';
import LazyImage from './LazyImage';

const MixesSection: React.FC = () => {
  return (
    <section id="mixes" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[url('/artwork/background-waves-3.png')] bg-cover bg-center opacity-30"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black via-purple-950/10 to-black"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-white mb-4 text-center">Latest Mix</h2>
        <p className="text-gray-400 max-w-2xl mx-auto text-center mb-16">
          Check out my latest house mix, featuring the best electronic beats of 2025.
        </p>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-900/30 rounded-xl border border-purple-900/30 p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              <div className="relative aspect-square">
                <LazyImage
                  src="https://ik.imagekit.io/bckqiai0e/1.png?updatedAt=1747750374575"
                  alt="Q2 House Mix 2025"
                  className="w-full h-full rounded-lg shadow-xl"
                />
              </div>
              <div className="flex items-center">
                <div>
                  <h3 className="text-2xl font-bold text-white mb-4">Q2 House Mix 2025</h3>
                  <p className="text-gray-400">
                    Experience the latest house music vibes in this exclusive mix, featuring carefully selected tracks that will keep you moving.
                  </p>
                  <div className="mt-6">
                    <SocialShare 
                      url="https://soundcloud.com/djlandantime/q2-house-mix-2025"
                      title="Q2 House Mix 2025 by DJ Landan Time"
                      description="Experience the latest house music vibes in this exclusive mix by DJ Landan Time"
                    />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="w-full">
              <iframe 
                width="100%" 
                height="300" 
                scrolling="no" 
                frameBorder="no" 
                allow="autoplay" 
                src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2096212773&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
                className="rounded-lg"
                title="Q2 House Mix 2025 by DJ Landan Time"
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MixesSection;